import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {InstanceResponse} from 'src/api/ProactApiClient';

export const useInstanceColumns = () => {
  const columns = useMemo<MRT_ColumnDef<InstanceResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        width: 250,
      },
      {
        accessorKey: 'internalIdentifier',
        header: 'Identifier',
      },
      {
        id: 'createdAt',
        accessorFn: row => (row.createdAt ? new Date(row.createdAt) : null),
        filterVariant: 'date',
        header: 'Created Date',
        Cell: ({cell}) => {
          const value = cell.getValue<Date | null>();
          return <>{value ? String(value).toShortDate() : ''}</>;
        },
      },
      {
        id: 'updatedAt',
        accessorFn: row => (row.updatedAt ? new Date(row.updatedAt) : null),
        filterVariant: 'date',
        header: 'Updated Date',
        Cell: ({cell}) => {
          const value = cell.getValue<Date | null>();
          return <>{value ? String(value).toShortDate() : ''}</>;
        },
      },
    ],
    []
  );

  return columns;
};
